    <template>
    <div>
        <!-- Single select contacts table -->
 
                <v-toolbar flat class="primary">
                    <h1 class="headline white--text">SEARCH CONTACTS</h1>
                </v-toolbar>
                 <v-card  flat>
                   <v-card-text>
                    <v-container grid-list-xs>
                    <v-layout wrap>
                        <v-text-field v-model="search2"
                                      append-icon="search"
                                      label="Search"
                                      single-line
                                      hide-details
                                      max-width="50px"
                                      class="pa-3"
                                      clearable></v-text-field>
                    </v-layout>
                    <v-data-table v-model="selected"
                                  :headers="headers2"
                                  :items="contacts"
                                  :pagination.sync="pagination"
                                  select-all
                                  :search="search2"
                                  item-key="id"
                                  class="elevation-1">
                        <template v-slot:headers="props">
                            <tr>
                                <th>
                                   
                                </th>
                                <th v-for="header in props.headers"
                                    :key="header.text"
                                    :class="['column sortable', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '']"
                                    @click="changeSort(header.value)">
                                    <v-icon small>arrow_upward</v-icon>
                                    {{ header.text }}
                                </th>
                            </tr>
                        </template>
                        <template v-slot:items="props">
                            <tr :active="props.selected" @click="props.selected = !props.selected; onSelection()">
                                <td>
                                                <v-checkbox :input-value="props.selected"
                                                primary
                                                @click="selected=[]"
                                                hide-details></v-checkbox>
                                </td>
                                <td class="text-xs-center">{{props.item.name}}</td>
                                <td class="text-xs-center">{{props.item.surname}}</td>
                                <td class="text-xs-center">{{props.item.idNumber}}</td>
                                <td class="text-xs-center">{{props.item.mobileNumber}}</td>                                
                            </tr>
                        </template>
                    </v-data-table>
                        <v-card-actions>
                        <v-spacer></v-spacer>
                          <v-btn color="primary" round @click="selected=[]; onSelection()">Cancel</v-btn>
                          <v-btn color="primary" round @click="onSelection()">Done</v-btn>
                       </v-card-actions>
                    </v-container>
                </v-card-text>
            </v-card>
         </div>
</template>
<!--////////////////////////////////////////////////////////////////////-->
<script>
    import Api from "@/services/Api";
    import format from "date-fns/format";

    export default {
        components: {
        },
        props: [ "contactsearchmodal",
               ],
        data: function () {
            return {
                contacts: [],
                selected: [],
                pagination: {},
                headers2: [
                    {
                        text: "Name",
                        align: "center",
                        value: "name"
                    },
                    {
                        text: "Surname",
                        align: "center",
                        value: "surname"
                    },
                    {
                        text: "ID Number",
                        align: "center",
                        value: "idNumber"
                    },
                    {
                        text: "Mobile Number",
                        align: "center",
                        value: "mobileNumber"
                    }
                ],
                search2: '',
            };
        },
        created() {
            this.initialize();
        },
        //////////////////////////////////////////////////////////////////////////////////////////////////////////////
        methods: {
            initialize() {
               this.fetchContacts()
            },
            onSelection(){
                    this.$emit('contactSelected', this.selected[0])                   
            },
            changeSort(column) {
                if (this.pagination.sortBy === column) {
                    this.pagination.descending = !this.pagination.descending
                } else {
                    this.pagination.sortBy = column
                    this.pagination.descending = false
                }
            },
            fetchContacts(){
            Api()
             .get('/contacts/active')
             .then(response=>{
              this.contacts=response.data
              });
            },         
        }
    };
</script>
<style>

</style>
